import {
    COMPETITION_RESULT_PATCH_FAILURE,
    COMPETITION_RESULT_PATCH_REQUEST,
    COMPETITION_RESULT_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const competitionResultPatchReducer = (state = initialState, action) => {
    const { type, sportsman, } = action;
    switch (type) {
        case COMPETITION_RESULT_PATCH_SUCCESS: {return {
            ...initialState,
            sportsman,
        }}

        case COMPETITION_RESULT_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case COMPETITION_RESULT_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
